import axios from 'axios';
import {
  DISTRIBUTION_SETUP_REQUEST,
  DISTRIBUTION_SETUP_SUCCESS,
  DISTRIBUTION_SETUP_FAIL,
  DISTRIBUTION_MY_RECORDS_REQUEST,
  DISTRIBUTION_MY_RECORDS_SUCCESS,
  DISTRIBUTION_MY_RECORDS_FAIL,
  DISTRIBUTION_SUBMIT_REQUEST,
  DISTRIBUTION_SUBMIT_SUCCESS,
  DISTRIBUTION_SUBMIT_FAIL,
  DISTRIBUTION_BULK_UPDATE_REQUEST,
  DISTRIBUTION_BULK_UPDATE_SUCCESS,
  DISTRIBUTION_BULK_UPDATE_FAIL,
} from '../constants/distributionConstants';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const authConfig = (userInfo) => ({
  headers: { Authorization: `Bearer ${userInfo.token}` },
});

const authJsonConfig = (userInfo) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userInfo.token}`,
  },
});

export const fetchDistributionSetupData = (month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: DISTRIBUTION_SETUP_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/distribution/setup-data?month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: DISTRIBUTION_SETUP_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DISTRIBUTION_SETUP_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const fetchMyDistributionRecords = (month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: DISTRIBUTION_MY_RECORDS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/distribution/my-records?month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: DISTRIBUTION_MY_RECORDS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DISTRIBUTION_MY_RECORDS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const submitDistributionRecords = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: DISTRIBUTION_SUBMIT_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.post(`${API_URL}/distribution/submit`, payload, authJsonConfig(userInfo));
    dispatch({ type: DISTRIBUTION_SUBMIT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DISTRIBUTION_SUBMIT_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const bulkUpdateDistributionRecords = (sections) => async (dispatch, getState) => {
  try {
    dispatch({ type: DISTRIBUTION_BULK_UPDATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(
      `${API_URL}/distribution/bulk-update`,
      { sections },
      authJsonConfig(userInfo),
    );
    dispatch({ type: DISTRIBUTION_BULK_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DISTRIBUTION_BULK_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};
